import React, { useEffect } from 'react'
import DefaultLayout from '../../components/DefaultLayout'
import Footer from '../../components/Footer/Footer'
import SubPageHeader from '../../components/SubPageHeader'
import ContentArea from '../../components/ContentArea'

import { setSessionItem } from '../../storeManager'
import { Link as HeadLink, Title } from 'react-head'
import PrivacyPolicyEN from '../../components/privacy-policy/PrivacyPolicyEN'

const PolicyPage = () => {
  useEffect(() => {
    setSessionItem('bannerShown', true)
  })

  return (
    <DefaultLayout>
      <Title>Privacy policy - Lifesum</Title>
      <HeadLink rel="canonical" href="https://lifesum.com/policy/" />
      <HeadLink
        rel="alternate"
        href={`https://lifesum.com/policy-de/`}
        // @ts-ignore
        hreflang="de"
      />
      <SubPageHeader
        heading="Privacy Policy & Terms of Service"
        stickyHeader={false}
      />
      <ContentArea>
        <div className="s-text">
          <PrivacyPolicyEN />
        </div>
      </ContentArea>
      <Footer />
    </DefaultLayout>
  )
}

export default PolicyPage
